import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { lastValueFrom } from 'rxjs';
import { BalanceType } from '../../../../../../shared/schemas/balanceSchema';
import { environment } from '../../../../environments/environments';
import { updateBalance } from '../../../store/slices/balanceSlice/balance.actions';
import { AppStore } from '../../../store/store';

@Injectable({
  providedIn: 'root'
})
export class BalanceService {
  private API_URL = environment.API_URL;

  constructor(private http: HttpClient, private store: Store<AppStore>) { }

  /**
   * Full balance history, newest first. Every fetch also pushes the newest
   * row into the store, so the synagogue total can never lag behind a list
   * the admin has just looked at.
   */
  async getBalance(): Promise<BalanceType[]> {
    const rows = await lastValueFrom(
      this.http.get<BalanceType[]>(`${this.API_URL}/synagogue/balance`),
    );
    if (rows[0]) this.store.dispatch(updateBalance({ balance: rows[0] }));
    return rows;
  }

  /**
   * Newest balance row, or null when there are no transactions yet.
   * Call after any write (add / delete transaction) to resync the store.
   */
  async refreshLatest(): Promise<BalanceType | null> {
    const rows = await this.getBalance();
    return rows[0] ?? null;
  }
}
